import request from '@/utils/request'

// 查询联系方式列表
export function listLianxi(query) {
  return request({
    url: '/ws/lianxi/list',
    method: 'get',
    params: query
  })
}

